import React from 'react';
import { ReactNode } from 'react';

import clsx from 'clsx';

import styles from './TableBodyCell.module.scss';

interface TableBodyCellProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const TableBodyCell = ({ children, className, onClick }: TableBodyCellProps) => {
  return (
    <div className={clsx(styles.tableBodyCell, className)} onClick={onClick}>
      <div className={styles.overflowedText}>{children}</div>
    </div>
  );
};

export default TableBodyCell;
